// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/home/communication-header-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/images/home/operations-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/images/home/hero-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/images/home/communication-header-mobile-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.communication-page .home-page-content .streamline {
  display: flex;
  margin-top: 22px;
  height: 664px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border-radius: 20px;
  background-size: cover;
}
.communication-page .home-page-content .streamline .streamline-left {
  width: 47%;
  height: 100%;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 100px 0 100px 100px;
  color: #fff;
}
.communication-page .home-page-content .streamline .streamline-left .streamline-title {
  font-size: 56px;
  font-weight: 600;
  line-height: 120%;
}
.communication-page .home-page-content .streamline .streamline-left .streamline-title .blue-part {
  color: #a5c7ff;
}
.communication-page .home-page-content .streamline .streamline-left .streamline-subtitle {
  margin-top: 24px;
  font-size: 22px;
  line-height: 180%;
}
.communication-page .home-page-content .streamline .streamline-left .request-demo-btn {
  margin-top: 46px;
  background-color: #fff;
  border: none;
  border-bottom: 2px solid #dee1e7;
  border-radius: 8px;
  padding: 12px 24px 12px 24px;
  gap: 8px;
  display: flex;
  align-items: center;
  width: 200px;
  height: 46px;
  color: #448aff;
  font-weight: 600;
  box-shadow: 0px 6px 10px -4px rgba(15, 23, 40, 0.1019607843);
  box-shadow: 0px 18px 32px -4px rgba(15, 23, 40, 0.2196078431);
}
.communication-page .home-page-content .streamline .streamline-right {
  height: 100%;
  position: relative;
  width: 57%;
}
.communication-page .home-page-content .streamline .streamline-right .streamline-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.communication-page .home-page-content .streamline .streamline-right::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, #3571d6 0%, rgba(53, 113, 214, 0) 39.9%);
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  pointer-events: none;
}
.communication-page .home-page-content .manual-process {
  padding: 120px 100px;
  display: flex;
}
.communication-page .home-page-content .manual-process .manual-process-left-block {
  padding: 20px 32px 20px 0;
  width: 44%;
  display: flex;
  align-items: center;
}
.communication-page .home-page-content .manual-process .manual-process-left-block .say-goodbye-title {
  color: #448aff;
  font-weight: 400;
  font-size: 40px;
  line-height: 120%;
}
.communication-page .home-page-content .manual-process .manual-process-left-block .say-goodbye-subtitle {
  margin-top: 20px;
  font-weight: 400;
  font-size: 20px;
  line-height: 180%;
}
.communication-page .home-page-content .manual-process .manual-process-right-block {
  width: 56%;
}
.communication-page .home-page-content .manual-process .manual-process-right-block .manual-process-list {
  width: 100%;
}
.communication-page .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item {
  min-height: 60px;
  padding: 12px 24px;
  border-left: 2px solid #a5c7ff;
  background: linear-gradient(90deg, #e7f0ff 0%, #ffffff 100%);
  margin-top: 12px;
  font-size: 20px;
  font-weight: 600;
  line-height: 180%;
  color: #040e46;
}
.communication-page .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(1) {
  margin-top: 0;
}
.communication-page .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(2) {
  margin-right: 68px;
  margin-left: 30px;
}
.communication-page .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(3) {
  margin-right: 38px;
  margin-left: 60px;
}
.communication-page .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item:nth-child(4) {
  margin-right: 8px;
  margin-left: 90px;
}
.communication-page .home-page-content .core-capabilities {
  padding: 80px;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-title {
  font-size: 40px;
  line-height: 120%;
  color: #3571d6;
  text-align: center;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 32px;
  margin-top: 46px;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item {
  position: relative;
  min-height: 260px;
  padding: 112px 36px 36px 36px;
  grid-column: span 4;
  background: linear-gradient(0deg, var(--Greyscale-Grey-5, #f9fafb), var(--Greyscale-Grey-5, #f9fafb)), radial-gradient(50% 161.19% at 50% 100%, rgba(68, 138, 255, 0) 50%, rgba(68, 138, 255, 0.1) 100%);
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item.core-capabilities-item-tall {
  grid-row: span 2;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item.core-capabilities-item-wide {
  grid-column: span 8;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item.core-capabilities-item-semi-wide {
  grid-column: span 6;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item .corner-image-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  text-align: right;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item .corner-image-wrapper svg {
  position: absolute;
  top: 42px;
  right: 42px;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-screenshot-img {
  width: 100%;
  height: 260px;
  background-size: cover;
  position: relative;
  z-index: 2;
  object-fit: cover;
  border-radius: 4px;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-content {
  position: relative;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-content .core-capabilities-item-title {
  color: #040e46;
  font-size: 26px;
  font-weight: 600;
  line-height: 130%;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item .core-capabilities-item-content .core-capabilities-item-subtitle {
  margin-top: 12px;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(3) {
  padding: 6px;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(3) .corner-image-wrapper {
  top: 215px;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(3) .core-capabilities-item-content {
  margin-top: 112px;
  margin-left: 36px;
  margin-right: 36px;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) {
  padding: 6px;
  display: flex;
  gap: 32px;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) .core-capabilities-item-screenshot-wrapper {
  width: calc(50% - 16px);
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) .core-capabilities-item-content {
  margin-top: 112px;
  margin-left: 36px;
  margin-right: 36px;
}
.communication-page .home-page-content .core-capabilities .core-capabilities-grid-container .core-capabilities-item:nth-child(4) .core-capabilities-item-right-block {
  width: calc(50% - 16px);
}
.communication-page .home-page-content .operations-see-in-action {
  background-color: #3571d6;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  padding: 60px;
  border-radius: 20px;
  background-size: cover;
  padding: 100px 100px 120px 100px;
}
.communication-page .home-page-content .operations-see-in-action .see-in-action-title {
  font-size: 40px;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.communication-page .home-page-content .operations-see-in-action .see-in-action-images-wrapper {
  display: flex;
  gap: 32px;
  margin-top: 80px;
}
.communication-page .home-page-content .operations-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper {
  flex: 1 1;
  max-width: 276px;
}
.communication-page .home-page-content .operations-see-in-action .see-in-action-images-wrapper .see-in-action-image-wrapper img {
  width: 100%;
  height: 100%;
  max-height: 276px;
  object-fit: cover;
  border-radius: 10px;
  object-position: center;
}
.communication-page .home-page-content .compliance-reviews-block {
  padding: 60px 100px;
  margin-top: 20px;
}
.communication-page .home-page-content .compliance-reviews-block .compliance-reviews-texts-wrapper {
  display: flex;
}
.communication-page .home-page-content .compliance-reviews-block .compliance-reviews-texts-wrapper .review-block-item {
  padding: 6px 40px;
  flex: 1 1;
}
.communication-page .home-page-content .compliance-reviews-block .compliance-reviews-texts-wrapper .review-block-item:nth-child(1) {
  padding-right: 80px;
  border-right: 1px solid #dee1e7;
}
.communication-page .home-page-content .compliance-reviews-block .compliance-reviews-texts-wrapper .review-block-item:nth-child(2) {
  padding-left: 80px;
}
.communication-page .home-page-content .compliance-reviews-block .compliance-reviews-texts-wrapper .review-block-item .review-text-wrapper {
  font-size: 28px;
  font-weight: 400;
  line-height: 130%;
  min-height: 260px;
}
.communication-page .home-page-content .compliance-reviews-block .compliance-reviews-texts-wrapper .review-block-item .review-text-wrapper .blue-part {
  color: #3571d6;
}
.communication-page .home-page-content .compliance-reviews-block .reviewers-wrapper {
  display: flex;
}
.communication-page .home-page-content .compliance-reviews-block .reviewers-wrapper .reviewer-wrapper {
  padding-top: 36px;
  display: flex;
  gap: 28px;
  flex: 1 1;
}
.communication-page .home-page-content .compliance-reviews-block .reviewers-wrapper .reviewer-wrapper:nth-child(1) {
  padding-left: 40px;
  padding-right: 40px;
  border-right: 1px solid #dee1e7;
}
.communication-page .home-page-content .compliance-reviews-block .reviewers-wrapper .reviewer-wrapper:nth-child(2) {
  padding-left: 80px;
}
.communication-page .home-page-content .compliance-reviews-block .reviewers-wrapper .reviewer-wrapper .reviewer-avatar-wrapper img {
  height: 100px;
  width: 100px;
  border-radius: 50%;
  object-fit: cover;
}
.communication-page .home-page-content .compliance-reviews-block .reviewers-wrapper .reviewer-wrapper .reviewer-name-wrapper {
  padding: 17px 0;
}
.communication-page .home-page-content .compliance-reviews-block .reviewers-wrapper .reviewer-wrapper .reviewer-name-wrapper .reviewer-name {
  font-size: 24px;
  font-weight: 600;
  line-height: 150%;
}
.communication-page .home-page-content .compliance-reviews-block .reviewers-wrapper .reviewer-wrapper .reviewer-name-wrapper .reviewer-position {
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
}
.communication-page .home-page-content .compliance-core-benefits {
  padding: 135px 100px 80px 100px;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  z-index: 1;
  border: 1px solid #eceef1;
}
.communication-page .home-page-content .compliance-core-benefits::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.35;
  z-index: 0;
  border-radius: 20px;
  mix-blend-mode: luminosity;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-title {
  color: #000;
  font-size: 40px;
  text-align: center;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider {
  margin-top: 80px;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .swiper {
  padding-bottom: 3rem;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .swiper .swiper-button-next,
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .swiper .swiper-button-prev {
  display: none;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .swiper .swiper-pagination-bullet {
  background: #fff;
  width: 10px;
  height: 10px;
  opacity: 1;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .swiper .swiper-pagination-bullet-active {
  background: #4b6fff;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .custom-nav {
  display: flex;
  justify-content: space-between;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .custom-nav button {
  position: relative;
  z-index: 10;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s;
  color: #3571d6;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .custom-nav button:hover {
  background-color: #f5f5f5;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .compliance-core-benefits-slide {
  position: relative;
  border-radius: 1rem;
  text-align: center;
  height: 230px;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .compliance-core-benefits-slide .compliance-core-benefits-slide-content {
  background-color: #fff;
  border-radius: 10px;
  height: 200px;
  padding: 80px 28px;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .compliance-core-benefits-slide .compliance-core-benefits-slide-content .compliance-core-benefits-title {
  color: #3571d6;
  font-size: 28px;
  font-weight: 600;
  line-height: 130%;
}
.communication-page .home-page-content .compliance-core-benefits .compliance-core-benefits-slider .compliance-core-benefits-slide .icon-wrapper {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  height: 90px;
  width: 90px;
  background-color: #3571d6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.communication-page.isMobile .home-page-content .streamline {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
  margin-top: 37px;
  height: unset;
}
.communication-page.isMobile .home-page-content .streamline .streamline-left {
  padding: 0 20px 20px 20px;
  margin-top: 240px;
  width: 100%;
}
.communication-page.isMobile .home-page-content .streamline .streamline-left .streamline-title {
  font-size: 32px;
}
.communication-page.isMobile .home-page-content .streamline .streamline-left .streamline-subtitle {
  font-size: 20px;
  margin-top: 16px;
  line-height: 160%;
}
.communication-page.isMobile .home-page-content .streamline .streamline-left .request-demo-btn {
  margin-top: 28px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 150%;
}
.communication-page.isMobile .home-page-content .manual-process {
  padding: 40px 20px 40px 20px;
  display: block;
}
.communication-page.isMobile .home-page-content .manual-process .manual-process-left-block {
  width: 100%;
  padding: 0;
}
.communication-page.isMobile .home-page-content .manual-process .manual-process-left-block .say-goodbye-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
}
.communication-page.isMobile .home-page-content .manual-process .manual-process-right-block {
  margin-top: 18px;
  width: 100%;
}
.communication-page.isMobile .home-page-content .manual-process .manual-process-right-block .manual-process-list .manual-process-list-item {
  font-weight: 600;
  font-size: 18px;
  line-height: 120%;
  min-height: unset;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-top: 10px !important;
}
.communication-page.isMobile .home-page-content .compliance-core-benefits {
  margin-top: 10px;
  padding: 40px 20px 20px 20px;
}
.communication-page.isMobile .home-page-content .compliance-core-benefits .compliance-core-benefits-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/subpages/Communication/styles.scss"],"names":[],"mappings":"AAEI;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,yDAAA;EACA,mBAAA;EACA,sBAAA;AADN;AAGM;EACE,UAAA;EACA,YAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,WAAA;AADR;AAGQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AADV;AAGU;EACE,cAAA;AADZ;AAKQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAHV;AAMQ;EACE,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,4BAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,4DAAA;EACA,6DAAA;AAJV;AAQM;EACE,YAAA;EACA,kBAAA;EACA,UAAA;AANR;AAQQ;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,6BAAA;EACA,gCAAA;AANV;AASQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,2EAAA;EACA,6BAAA;EACA,gCAAA;EACA,oBAAA;AAPV;AAYI;EACE,oBAAA;EACA,aAAA;AAVN;AAYM;EACE,yBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AAVR;AAYQ;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAVV;AAaQ;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAXV;AAeM;EACE,UAAA;AAbR;AAeQ;EACE,WAAA;AAbV;AAeU;EACE,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,4DAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAbZ;AAeY;EACE,aAAA;AAbd;AAgBY;EACE,kBAAA;EACA,iBAAA;AAdd;AAiBY;EACE,kBAAA;EACA,iBAAA;AAfd;AAkBY;EACE,iBAAA;EACA,iBAAA;AAhBd;AAuBI;EACE,aAAA;AArBN;AAuBM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AArBR;AAwBM;EACE,aAAA;EACA,sCAAA;EACA,SAAA;EACA,gBAAA;AAtBR;AAwBQ;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,mBAAA;EACA,wMAAA;AAtBV;AAyBU;EACE,gBAAA;AAvBZ;AA0BU;EACE,mBAAA;AAxBZ;AA2BU;EACE,mBAAA;AAzBZ;AA4BU;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,iBAAA;AA1BZ;AA4BY;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AA1Bd;AA8BU;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AA5BZ;AA+BU;EACE,kBAAA;AA7BZ;AA+BY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA7Bd;AAgCY;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA9Bd;AAkCU;EACE,YAAA;AAhCZ;AAkCY;EACE,UAAA;AAhCd;AAmCY;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AAjCd;AAqCU;EACE,YAAA;EACA,aAAA;EACA,SAAA;AAnCZ;AAqCY;EACE,uBAAA;AAnCd;AAsCY;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AApCd;AAuCY;EACE,uBAAA;AArCd;AA4CI;EACE,yBAAA;EACA,yDAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;AA1CN;AA4CM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AA1CR;AA6CM;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AA3CR;AA6CQ;EACE,SAAA;EACA,gBAAA;AA3CV;AA6CU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AA3CZ;AAiDI;EACE,mBAAA;EACA,gBAAA;AA/CN;AAiDM;EACE,aAAA;AA/CR;AAiDQ;EACE,iBAAA;EACA,SAAA;AA/CV;AAiDU;EACE,mBAAA;EACA,+BAAA;AA/CZ;AAkDU;EACE,kBAAA;AAhDZ;AAmDU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAjDZ;AAmDY;EACE,cAAA;AAjDd;AAuDM;EACE,aAAA;AArDR;AAuDQ;EACE,iBAAA;EACA,aAAA;EACA,SAAA;EACA,SAAA;AArDV;AAuDU;EACE,kBAAA;EACA,mBAAA;EACA,+BAAA;AArDZ;AAwDU;EACE,kBAAA;AAtDZ;AA0DY;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAxDd;AA4DU;EACE,eAAA;AA1DZ;AA4DY;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA1Dd;AA6DY;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA3Dd;AAkEI;EACE,+BAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AAhEN;AAkEM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,0BAAA;AAhER;AAmEM;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AAjER;AAoEM;EACE,gBAAA;AAlER;AAoEQ;EACE,oBAAA;AAlEV;AAoEU;;EAEE,aAAA;AAlEZ;AAqEU;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAnEZ;AAsEU;EACE,mBAAA;AApEZ;AAwEQ;EACE,aAAA;EACA,8BAAA;AAtEV;AAwEU;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yCAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AAtEZ;AAuEY;EACE,yBAAA;AArEd;AA0EQ;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAxEV;AA0EU;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAxEZ;AA0EY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAxEd;AA4EU;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1EZ;;AAoFI;EACE,yDAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AAjFN;AAmFM;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;AAjFR;AAmFQ;EACE,eAAA;AAjFV;AAoFQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAlFV;AAqFQ;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AAnFV;AAwFI;EACE,4BAAA;EACA,cAAA;AAtFN;AAwFM;EACE,WAAA;EACA,UAAA;AAtFR;AAwFQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAtFV;AA0FM;EACE,gBAAA;EACA,WAAA;AAxFR;AA2FU;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;AAzFZ;AA+FI;EACE,gBAAA;EACA,4BAAA;AA7FN;AA+FM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA7FR","sourcesContent":[".communication-page {\n  .home-page-content {\n    .streamline {\n      display: flex;\n      margin-top: 22px;\n      height: 664px;\n      background-image: url('../../../../assets/images/home/communication-header-bg.png');\n      border-radius: 20px;\n      background-size: cover;\n\n      .streamline-left {\n        width: 47%;\n        height: 100%;\n        border-top-left-radius: 20px;\n        border-bottom-left-radius: 20px;\n        padding: 100px 0 100px 100px;\n        color: #fff;\n\n        .streamline-title {\n          font-size: 56px;\n          font-weight: 600;\n          line-height: 120%;\n\n          .blue-part {\n            color: #a5c7ff;\n          }\n        }\n\n        .streamline-subtitle {\n          margin-top: 24px;\n          font-size: 22px;\n          line-height: 180%;\n        }\n\n        .request-demo-btn {\n          margin-top: 46px;\n          background-color: #fff;\n          border: none;\n          border-bottom: 2px solid #dee1e7;\n          border-radius: 8px;\n          padding: 12px 24px 12px 24px;\n          gap: 8px;\n          display: flex;\n          align-items: center;\n          width: 200px;\n          height: 46px;\n          color: #448aff;\n          font-weight: 600;\n          box-shadow: 0px 6px 10px -4px #0f17281a;\n          box-shadow: 0px 18px 32px -4px #0f172838;\n        }\n      }\n\n      .streamline-right {\n        height: 100%;\n        position: relative;\n        width: 57%;\n\n        .streamline-image {\n          height: 100%;\n          width: 100%;\n          object-fit: cover;\n          border-top-right-radius: 20px;\n          border-bottom-right-radius: 20px;\n        }\n\n        &::before {\n          content: '';\n          position: absolute;\n          top: 0;\n          left: 0;\n          height: 100%;\n          width: 100%;\n          background: linear-gradient(90deg, #3571d6 0%, rgba(53, 113, 214, 0) 39.9%);\n          border-top-right-radius: 20px;\n          border-bottom-right-radius: 20px;\n          pointer-events: none; // allows clicks to pass through\n        }\n      }\n    }\n\n    .manual-process {\n      padding: 120px 100px;\n      display: flex;\n\n      .manual-process-left-block {\n        padding: 20px 32px 20px 0;\n        width: 44%;\n        display: flex;\n        align-items: center;\n\n        .say-goodbye-title {\n          color: #448aff;\n          font-weight: 400;\n          font-size: 40px;\n          line-height: 120%;\n        }\n\n        .say-goodbye-subtitle {\n          margin-top: 20px;\n          font-weight: 400;\n          font-size: 20px;\n          line-height: 180%;\n        }\n      }\n\n      .manual-process-right-block {\n        width: 56%;\n\n        .manual-process-list {\n          width: 100%;\n\n          .manual-process-list-item {\n            min-height: 60px;\n            padding: 12px 24px;\n            border-left: 2px solid #a5c7ff;\n            background: linear-gradient(90deg, #e7f0ff 0%, #ffffff 100%);\n            margin-top: 12px;\n            font-size: 20px;\n            font-weight: 600;\n            line-height: 180%;\n            color: #040e46;\n\n            &:nth-child(1) {\n              margin-top: 0;\n            }\n\n            &:nth-child(2) {\n              margin-right: 68px;\n              margin-left: 30px;\n            }\n\n            &:nth-child(3) {\n              margin-right: 38px;\n              margin-left: 60px;\n            }\n\n            &:nth-child(4) {\n              margin-right: 8px;\n              margin-left: 90px;\n            }\n          }\n        }\n      }\n    }\n\n    .core-capabilities {\n      padding: 80px;\n\n      .core-capabilities-title {\n        font-size: 40px;\n        line-height: 120%;\n        color: #3571d6;\n        text-align: center;\n      }\n\n      .core-capabilities-grid-container {\n        display: grid;\n        grid-template-columns: repeat(12, 1fr);\n        gap: 32px;\n        margin-top: 46px;\n\n        .core-capabilities-item {\n          position: relative;\n          min-height: 260px;\n          padding: 112px 36px 36px 36px;\n          grid-column: span 4;\n          background: linear-gradient(0deg, var(--Greyscale-Grey-5, #f9fafb), var(--Greyscale-Grey-5, #f9fafb)),\n            radial-gradient(50% 161.19% at 50% 100%, rgba(68, 138, 255, 0) 50%, rgba(68, 138, 255, 0.1) 100%);\n\n          &.core-capabilities-item-tall {\n            grid-row: span 2;\n          }\n\n          &.core-capabilities-item-wide {\n            grid-column: span 8;\n          }\n\n          &.core-capabilities-item-semi-wide {\n            grid-column: span 6;\n          }\n\n          .corner-image-wrapper {\n            position: absolute;\n            right: 0;\n            top: 0;\n            text-align: right;\n\n            svg {\n              position: absolute;\n              top: 42px;\n              right: 42px;\n            }\n          }\n\n          .core-capabilities-item-screenshot-img {\n            width: 100%;\n            height: 260px;\n            background-size: cover;\n            position: relative;\n            z-index: 2;\n            object-fit: cover;\n            border-radius: 4px;\n          }\n\n          .core-capabilities-item-content {\n            position: relative;\n\n            .core-capabilities-item-title {\n              color: #040e46;\n              font-size: 26px;\n              font-weight: 600;\n              line-height: 130%;\n            }\n\n            .core-capabilities-item-subtitle {\n              margin-top: 12px;\n              font-weight: 400;\n              font-size: 18px;\n              line-height: 150%;\n            }\n          }\n\n          &:nth-child(3) {\n            padding: 6px;\n\n            .corner-image-wrapper {\n              top: 215px;\n            }\n\n            .core-capabilities-item-content {\n              margin-top: 112px;\n              margin-left: 36px;\n              margin-right: 36px;\n            }\n          }\n\n          &:nth-child(4) {\n            padding: 6px;\n            display: flex;\n            gap: 32px;\n\n            .core-capabilities-item-screenshot-wrapper {\n              width: calc(50% - 16px);\n            }\n\n            .core-capabilities-item-content {\n              margin-top: 112px;\n              margin-left: 36px;\n              margin-right: 36px;\n            }\n\n            .core-capabilities-item-right-block {\n              width: calc(50% - 16px);\n            }\n          }\n        }\n      }\n    }\n\n    .operations-see-in-action {\n      background-color: #3571d6;\n      background-image: url('../../../../assets/images/home/operations-bg.svg');\n      padding: 60px;\n      border-radius: 20px;\n      background-size: cover;\n      padding: 100px 100px 120px 100px;\n\n      .see-in-action-title {\n        font-size: 40px;\n        font-weight: 400;\n        color: #fff;\n        text-align: center;\n      }\n\n      .see-in-action-images-wrapper {\n        display: flex;\n        gap: 32px;\n        margin-top: 80px;\n\n        .see-in-action-image-wrapper {\n          flex: 1;\n          max-width: 276px;\n\n          img {\n            width: 100%;\n            height: 100%;\n            max-height: 276px;\n            object-fit: cover;\n            border-radius: 10px;\n            object-position: center;\n          }\n        }\n      }\n    }\n\n    .compliance-reviews-block {\n      padding: 60px 100px;\n      margin-top: 20px;\n\n      .compliance-reviews-texts-wrapper {\n        display: flex;\n\n        .review-block-item {\n          padding: 6px 40px;\n          flex: 1;\n\n          &:nth-child(1) {\n            padding-right: 80px;\n            border-right: 1px solid #dee1e7;\n          }\n\n          &:nth-child(2) {\n            padding-left: 80px;\n          }\n\n          .review-text-wrapper {\n            font-size: 28px;\n            font-weight: 400;\n            line-height: 130%;\n            min-height: 260px;\n\n            .blue-part {\n              color: #3571d6;\n            }\n          }\n        }\n      }\n\n      .reviewers-wrapper {\n        display: flex;\n\n        .reviewer-wrapper {\n          padding-top: 36px;\n          display: flex;\n          gap: 28px;\n          flex: 1;\n\n          &:nth-child(1) {\n            padding-left: 40px;\n            padding-right: 40px;\n            border-right: 1px solid #dee1e7;\n          }\n\n          &:nth-child(2) {\n            padding-left: 80px;\n          }\n\n          .reviewer-avatar-wrapper {\n            img {\n              height: 100px;\n              width: 100px;\n              border-radius: 50%;\n              object-fit: cover;\n            }\n          }\n\n          .reviewer-name-wrapper {\n            padding: 17px 0;\n\n            .reviewer-name {\n              font-size: 24px;\n              font-weight: 600;\n              line-height: 150%;\n            }\n\n            .reviewer-position {\n              font-size: 18px;\n              font-weight: 400;\n              line-height: 150%;\n            }\n          }\n        }\n      }\n    }\n\n    .compliance-core-benefits {\n      padding: 135px 100px 80px 100px;\n      width: 100%;\n      border-radius: 20px;\n      overflow: hidden;\n      position: relative;\n      z-index: 1;\n      border: 1px solid #eceef1;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-image: url('../../../../assets/images/home/hero-bg.png');\n        background-size: cover;\n        background-repeat: no-repeat;\n        background-position: center;\n        opacity: 0.35;\n        z-index: 0;\n        border-radius: 20px;\n        mix-blend-mode: luminosity;\n      }\n\n      .compliance-core-benefits-title {\n        color: #000;\n        font-size: 40px;\n        text-align: center;\n      }\n\n      .compliance-core-benefits-slider {\n        margin-top: 80px;\n\n        .swiper {\n          padding-bottom: 3rem;\n\n          .swiper-button-next,\n          .swiper-button-prev {\n            display: none;\n          }\n\n          .swiper-pagination-bullet {\n            background: #fff;\n            width: 10px;\n            height: 10px;\n            opacity: 1;\n          }\n\n          .swiper-pagination-bullet-active {\n            background: #4b6fff;\n          }\n        }\n\n        .custom-nav {\n          display: flex;\n          justify-content: space-between;\n\n          button {\n            position: relative;\n            z-index: 10;\n            width: 48px;\n            height: 48px;\n            border-radius: 50%;\n            background-color: #fff;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border: none;\n            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n            cursor: pointer;\n            transition: all 0.2s;\n            color: #3571d6;\n            &:hover {\n              background-color: #f5f5f5;\n            }\n          }\n        }\n\n        .compliance-core-benefits-slide {\n          position: relative;\n          border-radius: 1rem;\n          text-align: center;\n          height: 230px;\n\n          .compliance-core-benefits-slide-content {\n            background-color: #fff;\n            border-radius: 10px;\n            height: 200px;\n            padding: 80px 28px;\n\n            .compliance-core-benefits-title {\n              color: #3571d6;\n              font-size: 28px;\n              font-weight: 600;\n              line-height: 130%;\n            }\n          }\n\n          .icon-wrapper {\n            position: absolute;\n            top: 0;\n            left: 50%;\n            transform: translate(-50%, 0);\n            height: 90px;\n            width: 90px;\n            background-color: #3571d6;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n      }\n    }\n  }\n}\n\n.communication-page.isMobile {\n  .home-page-content {\n    .streamline {\n      background-image: url('../../../../assets/images/home/communication-header-mobile-bg.png');\n      background-size: cover;\n      margin-top: 37px;\n      height: unset;\n\n      .streamline-left {\n        padding: 0 20px 20px 20px;\n        margin-top: 240px;\n        width: 100%;\n\n        .streamline-title {\n          font-size: 32px;\n        }\n\n        .streamline-subtitle {\n          font-size: 20px;\n          margin-top: 16px;\n          line-height: 160%;\n        }\n\n        .request-demo-btn {\n          margin-top: 28px;\n          width: 100%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 16px;\n          line-height: 150%;\n        }\n      }\n    }\n\n    .manual-process {\n      padding: 40px 20px 40px 20px;\n      display: block;\n\n      .manual-process-left-block {\n        width: 100%;\n        padding: 0;\n\n        .say-goodbye-title {\n          font-weight: 400;\n          font-size: 32px;\n          line-height: 120%;\n        }\n      }\n\n      .manual-process-right-block {\n        margin-top: 18px;\n        width: 100%;\n\n        .manual-process-list {\n          .manual-process-list-item {\n            font-weight: 600;\n            font-size: 18px;\n            line-height: 120%;\n            min-height: unset;\n            margin-left: 0 !important;\n            margin-right: 0 !important;\n            margin-top: 10px !important;\n          }\n        }\n      }\n    }\n\n    .compliance-core-benefits {\n      margin-top: 10px;\n      padding: 40px 20px 20px 20px;\n\n      .compliance-core-benefits-title {\n        font-weight: 400;\n        font-size: 32px;\n        line-height: 120%;\n        text-align: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
